import { render, staticRenderFns } from "./ModalRate.vue?vue&type=template&id=77a8ef60&scoped=true"
import script from "./ModalRate.vue?vue&type=script&lang=js"
export * from "./ModalRate.vue?vue&type=script&lang=js"
import style0 from "./ModalRate.vue?vue&type=style&index=0&id=77a8ef60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8ef60",
  null
  
)

export default component.exports